export const oemTabs = [{ label: "Details", value: "details" }];
